/**
 * sl-728o.3.1: Input Batch Session
 *
 * Uses closure variable instead of useRef for slider save/restore.
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createInputBatchSession(t: I18n): TutorialSession {
  let originalBatchSize: number | null = null;

  return {
    id: 'automation:inputBatch',
    context: {
      targetAudience: 'technical',
      category: 'automation',
      tab: 'input',
    },
    steps: [
      {
        targetSelector: '[data-section="batch-size"] input[type="range"]',
        title: t['com.streamlain.streamlain.coach.batch-slider.title'](),
        content: t['com.streamlain.streamlain.coach.batch-slider.content'](),
        animation: 'pulse',
      },
      {
        targetSelector: '[data-section="batch-size"] input[type="range"]',
        title: t['com.streamlain.streamlain.coach.batch-drag.title'](),
        content: t['com.streamlain.streamlain.coach.batch-drag.content'](),
        animation: 'highlight',
        onEnter: () => {
          const slider = document.querySelector(
            '[data-section="batch-size"] input[type="range"]'
          ) as HTMLInputElement | null;
          if (slider) {
            originalBatchSize = parseInt(slider.value, 10);
            slider.value = '25';
            slider.dispatchEvent(new Event('input', { bubbles: true }));
            slider.dispatchEvent(new Event('change', { bubbles: true }));
          }
        },
        onExit: () => {
          const slider = document.querySelector(
            '[data-section="batch-size"] input[type="range"]'
          ) as HTMLInputElement | null;
          if (slider && originalBatchSize !== null) {
            slider.value = String(originalBatchSize);
            slider.dispatchEvent(new Event('input', { bubbles: true }));
            slider.dispatchEvent(new Event('change', { bubbles: true }));
            originalBatchSize = null;
          }
        },
        delay: 200,
      },
      {
        targetSelector: '[data-coachmark-target="batch-value"]',
        title: t['com.streamlain.streamlain.coach.batch-result.title'](),
        content: t['com.streamlain.streamlain.coach.batch-result.content'](),
        animation: 'highlight',
      },
    ],
  };
}
